import { Card, Space, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Button } from '~/app/components/common/Button';
import { usePreventiveMaintenanceColumns } from './hooks/usePreventiveMaintenanceColumns';
import { usePreventiveMaintenancePage } from './hooks/usePreventiveMaintenancePage';
import type { PlanRow } from './types';
import { EvimoTable } from '~/app/components/common/EvimoTable/EvimoTable';

const { Title, Paragraph } = Typography;

export function PreventiveMaintenancePageContainer() {
  const { t } = useTranslation('maintenance');
  const { rows, isLoading, goToCreate, goToPlan } =
    usePreventiveMaintenancePage();
  const columns = usePreventiveMaintenanceColumns();

  return (
    <Space direction="vertical" size={24} style={{ width: '100%' }}>
      <div>
        <Title level={2} style={{ marginBottom: 8 }}>
          {t('plans.title')}
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          {t('plans.description')}
        </Paragraph>
      </div>

      <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
        <Button type="primary" icon={<PlusOutlined />} onClick={goToCreate}>
          {t('plans.create')}
        </Button>
      </Space>

      <Card
        style={{ borderRadius: 16, border: '1px solid #e2e8f0' }}
        styles={{ body: { padding: 0 } }}
      >
        <EvimoTable<PlanRow>
          rowKey="id"
          loading={isLoading}
          columns={columns}
          dataSource={rows}
          pagination={{ pageSize: 10, showSizeChanger: true }}
          size="middle"
          onRow={(record) => ({
            style: { cursor: 'pointer' },
            onClick: () => goToPlan(record.id),
          })}
        />
      </Card>
    </Space>
  );
}
